
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { IRecipient } from '@/entities/notices'
import 'driver.js/dist/driver.min.css'
import ChatInput from '@/components/Chat/ChatInput.vue'
import RecipientPicker from '@/components/Notices/RecipientPicker.vue'
import BaseButton from '@/components/Rain/Buttons/BaseButton.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<DesktopRecipientPicker>({
    components: {
        Typography,
        BaseButton,
        ChatInput,
        RecipientPicker,
    },
})
export default class DesktopRecipientPicker extends Vue {
    @Prop(Boolean) public single!: boolean // only allow single selection
    @Prop({ type: Boolean, default: true }) public allowEmpty!: boolean // allow empty selection
    @Prop(Array) public selected!: IRecipient[]
    @Prop(Array) public recipients!: IRecipient[]
    @Prop(String) public title!: string
    @Prop({ type: Boolean, default: false }) public canPickVirtualUsers!: string

    private selectedRecipients: IRecipient[] = []

    public async mounted() {
        this.selectedRecipients = [...this.selected]
        // Purge the unclean.  Remove any user not part of the recipients list to avoid errors.
        this.selectedRecipients = this.selectedRecipients.filter((s) =>
            this.recipients.map((r) => r.user_id).includes(s.user_id)
        )
    }

    private get disableSave(): boolean {
        return !(
            this.allowEmpty ||
            (!this.allowEmpty && this.selectedRecipients.length > 0)
        )
    }

    private onToggleRecipient(
        selectedRecipients: IRecipient[],
        changedRecipient: IRecipient
    ) {
        this.selectedRecipients = selectedRecipients
        if (this.single && this.selectedRecipients.length) {
            this.selectedRecipients = [changedRecipient]
        }
    }

    private clearSelectedRecipients() {
        this.selectedRecipients = []
    }

    private onCancelRecipients() {
        this.selectedRecipients = this.selected
        this.$emit('close')
    }

    private onConfirmRecipients() {
        this.$emit('confirm', this.selectedRecipients)
    }
}
